// extracted by mini-css-extract-plugin
module.exports = {"order":"styles_order__VWRDo","gap":"styles_gap__0yrzn","centerContent":"styles_centerContent__KpT9F"};